import { MainButton } from 'elements/button/MainButton';
import { useGuideShareLinks } from 'hooks/guide/useGuideShareLinks';
import { EColors, EFonts } from 'libs/styles/styling';
import { useContext } from 'react';
import { useNavigate } from 'react-router';
import { CtxEdit } from 'session/ctxEdit';
import { GlobalContext } from 'session/state/context';
import { setLoggedUser } from 'session/state/user/userActions';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const MinuteHeaderRight = (props: Props): JSX.Element => {
    const navigate = useNavigate();
    const globalContext = useContext(GlobalContext);
    const guideShareLinks = useGuideShareLinks();
    const ctxEdit = useContext(CtxEdit);

    const user = globalContext.state.loggedUser;

    const previewLink = guideShareLinks.getMapViewLink({
        worldMapId: ctxEdit.map?.worldMapId,
        guideId: ctxEdit.map?.guideId,
        guideType: null
    });

    function getUsername() {
        if (user.email?.startsWith('lukas+') || user.email?.startsWith('jan+')) {
            return user.userId;
        }
        // Some old account don't have email
        return user.email ?? user.userId;
    }

    return (
        <S_MinuteHeaderRight className={props.className}>
            {user && (
                <S_Profile>
                    <S_ProfileName>
                        <S_Name
                            onClick={() => {
                                navigate('/admin');
                            }}
                        >
                            {getUsername()}
                        </S_Name>
                        <S_Out
                            onClick={() => {
                                globalContext.dispatch(setLoggedUser(null));
                                navigate('/');
                            }}
                        >
                            &nbsp;({Localization.LOG_OUT})
                        </S_Out>
                    </S_ProfileName>
                </S_Profile>
            )}
            {!user && (
                <S_Login
                    type={'primary'}
                    onClick={() => {
                        navigate('/login');
                    }}
                >
                    {Localization.LOGIN}
                </S_Login>
            )}
            <S_ExpertButton
                type={'secondary'}
                onClick={() => {
                    window.open(previewLink);
                }}
            >
                {Localization.PREVIEW_MAP}
            </S_ExpertButton>
        </S_MinuteHeaderRight>
    );
};

const S_MinuteHeaderRight = styled.div`
    display: flex;
    justify-content: flex-end;
`;

const S_ExpertButton = styled(MainButton)`
    margin: 0 15px 0 0;
`;

const S_Profile = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 5px 0 0;
`;

const S_ProfileName = styled.div`
    color: white;
    padding: 0px 10px 0 0;
`;

const S_Name = styled.span`
    cursor: pointer;
`;

const S_Out = styled.span`
    font-size: 14px;
    font-family: ${EFonts.Regular};
    cursor: pointer;
    &:hover {
        color: ${EColors.ACC1_A};
    }
`;

const S_Login = styled(MainButton)`
    margin: 0 15px 0 0;
`;
